import { TableCell, TableSortLabel } from '@mui/material';
import type {
  CatalogSortColumn,
  ColumnId,
} from './CatalogTable.types';
import { COLUMN_DEFINITIONS } from './CatalogTable.types';

interface CatalogTableHeadersProps {
  columnId: ColumnId;
  sortBy: CatalogSortColumn;
  sortOrder: 'asc' | 'desc';
  onSort: (column: CatalogSortColumn) => void;
}

export const CatalogTableHeaders = ({
  columnId,
  sortBy,
  sortOrder,
  onSort,
}: CatalogTableHeadersProps) => {
  const columnDef = COLUMN_DEFINITIONS.find((c) => c.id === columnId);
  if (!columnDef) return null;

  if (!columnDef.sortable) {
    return <TableCell key={columnId}>{columnDef.label}</TableCell>;
  }

  const sortColumn = columnId as CatalogSortColumn;
  return (
    <TableCell key={columnId}>
      <TableSortLabel
        active={sortBy === sortColumn}
        direction={sortBy === sortColumn ? sortOrder : 'asc'}
        onClick={() => onSort(sortColumn)}
      >
        {columnDef.label}
      </TableSortLabel>
    </TableCell>
  );
};
